module.exports = __webpack_public_path__ + "@/assets/img/repayment.5cc79111.png";